// Saved needs an account, so only a signed-in visitor has it.
export const MAP_FILTERS = [
    { id: 'all', label: 'All homes' },
    { id: 'not-seen', label: 'Not yet seen' },
    { id: 'checked-in', label: 'Checked in' },
    { id: 'saved', label: 'Saved', icon: 'bi-heart', signedIn: true },
];
// Homes are a set, not a route: every announced home with a point, in the order the tour keeps them.
export const mapHomes = (stops) => stops.flatMap(stop => stop.title === '' || stop.lat === null || stop.lng === null
    ? []
    : [Object.assign(Object.assign({}, stop), { lat: stop.lat, lng: stop.lng })]);
// A home is saved by its property, which the tour names only once it has begun.
const isSavedHome = (home, isSaved) => home.propertyId !== null && isSaved(home.propertyId);
export const filterHomes = (homes, filter, visited, isSaved) => filter === 'all' ? homes
    : filter === 'checked-in' ? homes.filter(h => visited.includes(h.id))
        : filter === 'saved' ? homes.filter(h => isSavedHome(h, isSaved))
            : homes.filter(h => !visited.includes(h.id));
export const EMPTY_FILTER_MESSAGE = {
    'all': 'The homes on this tour have not been placed on the map yet.',
    'not-seen': 'You have checked in at every home. Nicely done.',
    'checked-in': 'You have not checked in at any home yet. Check in from a home\'s page when you visit.',
    'saved': 'You have not saved any homes on this tour yet. Tap the heart on a home to keep it.',
};
